module.exports = __webpack_public_path__ + "static/img/exclusive-gateway.64d2bf03.svg";